import React, {Component} from 'react';
import {connect} from 'react-redux';
import {sumBy, filter} from 'lodash';
import {reduxForm, FieldArray, formValueSelector} from 'redux-form';
import {Card, Table, Form, Loader, Button, Icon, Dimmer} from 'semantic-ui-react';
import {QUALITY_ASSURANCE_ORDERS_FORM} from '../../../common/forms';
import {ordersStatus} from '../../../common/dictionaries/accessories';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {getNumericValue} from '../../../common/util/fieldsValidation';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import OutsourcedInfoModal from './modal/outsourced';
import TasksAssignmentTableItems from './tableItems';
import './tasks.scss';

class TasksAssignment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'modalWasOpen': false,
      'index': '',
    };
    this.renderTable = this.renderTable.bind(this);
    this.onCancelClick = this.onCancelClick.bind(this);
    this.saveOrDeleteItem = this.saveOrDeleteItem.bind(this);
    this.closeStockDownloadModal = this.closeStockDownloadModal.bind(this);
    this.handleState = this.handleState.bind(this);
  }

  componentDidMount() {
    const {order, permissions} = this.props;
    if (
      !hasAccessPermission(
        permissions,
        resources.QualityAssuranceOrders,
        scopes.Create
      )
    ) {
      this.props.push(paths.AccessDenied);
    }
    this.props.fetchQualityAssuranceOrder(order);
    this.props.fetchTechnicians({'action': 'create_quality_assurance_task'});
    this.props.fetchTasksAvailableByOrder(order);
    this.props.fetchTasksForQualityAssuranceOrder(order);
  }

  onCancelClick() {
    this.props.goBack();
  }

  saveOrDeleteItem(index, action, item) {
    const {order} = this.props;
    const data = {...item};
    data.action = action;
    this.props.manageTasksInQualityAssuranceOrder(order, index, data);
  }

  addItem(fields) {
    const allItems = fields.getAll();
    const itemsSaved = filter(allItems, {'itemSaved': true});
    if (allItems.length !== itemsSaved.length) {
      this.props.addMessageBoxError(
        'Llene todos los campos requeridos antes de agregar un nuevo item'
      );
      return;
    }
    fields.push({});
  }

  handleState(value) {
    this.setState(value);
  }

  closeStockDownloadModal(action, outsourcedInfo) {
    this.setState({
      'modalWasOpen': false,
    });

    if (action === 'close') {
      return;
    }
    const {tasks} = this.props;
    const {index} = this.state;

    this.props.addOutsourcedInfo(index, outsourcedInfo);
    const data = {...tasks[index], ...outsourcedInfo};
    this.saveOrDeleteItem(index, 'add', data);
  }

  renderTotals() {
    const {tasks, orderStatus} = this.props;
    const totalAmount = sumBy(tasks, 'totalPrice');

    if (!tasks.length) {
      return;
    }

    return (
      <Table.Row textAlign='center' className='totals-row'>
        <Table.Cell textAlign='left' colSpan={3}>
          <span>TOTAL</span>
        </Table.Cell>
        <Table.Cell textAlign='right' className='qty-column'>
          <span>{sumBy(tasks, 'quantity')}</span>
        </Table.Cell>
        <Table.Cell />
        <Table.Cell />
        <Table.Cell textAlign='right'>
          <span>
            {'$'}
            {getNumericValue(totalAmount, 2)}
          </span>
        </Table.Cell>
        <Table.Cell />
        <Table.Cell />
        {orderStatus && orderStatus === ordersStatus.assigned_technicians && (
          <Table.Cell />
        )}
      </Table.Row>
    );
  }

  renderTable({fields}) {
    const {orderStatus, order} = this.props;
    return (
      <div>
        <Table striped>
          <Table.Header>
            <Table.Row textAlign='center'>
              <Table.HeaderCell className='task-column'>Tarea</Table.HeaderCell>
              <Table.HeaderCell>Tiempo Tarea</Table.HeaderCell>
              <Table.HeaderCell>Responsable</Table.HeaderCell>
              <Table.HeaderCell className='qty-column'>Cant.</Table.HeaderCell>
              <Table.HeaderCell className='outsourced-column'>
                Subcontratado
              </Table.HeaderCell>
              <Table.HeaderCell>Precio Unitario</Table.HeaderCell>
              <Table.HeaderCell>Precio Total</Table.HeaderCell>
              <Table.HeaderCell className='technician-column'>
                Técnico Asignado
              </Table.HeaderCell>
              <Table.HeaderCell>Estado</Table.HeaderCell>
              {orderStatus &&
                orderStatus === ordersStatus.assigned_technicians && (
                <Table.HeaderCell>Acciones</Table.HeaderCell>
              )}
            </Table.Row>
          </Table.Header>

          <Table.Body>
            <TasksAssignmentTableItems
              fields={fields}
              order={order}
              saveOrDeleteItem={this.saveOrDeleteItem}
              handleState={this.handleState}
            />
            {this.renderTotals()}
          </Table.Body>
        </Table>

        {orderStatus && orderStatus === ordersStatus.assigned_technicians && (
          <div className='addItem' onClick={() => this.addItem(fields)}>
            <Icon name='add' />
            <strong>AGREGAR REGISTRO</strong>
          </div>
        )}
      </div>
    );
  }

  renderLoader() {
    const {savingItem} = this.props;
    if (savingItem) {
      return (
        <Dimmer active inverted>
          <Loader inverted content='Procesando' />
        </Dimmer>
      );
    }
  }

  render() {
    const {order, loading, savingItem, tasks} = this.props;
    const {modalWasOpen, index} = this.state;

    return (
      <div className='tasks-assignment'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <Icon name='arrow left' onClick={this.onCancelClick} />
              <h2>Asignación de tareas para la orden: {order}</h2>
              <div className='title-bar-actions'>
                <Button
                  disabled={loading || savingItem}
                  onClick={this.onCancelClick}
                >
                  Cancelar
                </Button>
              </div>
            </div>
          </div>
        </Card>

        <Card raised fluid>
          <OutsourcedInfoModal
            modalWasOpen={modalWasOpen}
            element={tasks[index]}
            onCloseModal={this.closeStockDownloadModal}
          />
          {this.renderLoader()}
          <Form className='primary-content'>
            <FieldArray name='tasks' component={this.renderTable} />
          </Form>
        </Card>
      </div>
    );
  }
}

export {TasksAssignment};

const form = reduxForm({
  'form': QUALITY_ASSURANCE_ORDERS_FORM.name,
})(TasksAssignment);

const mapStateToProps = (state, ownProps) => {
  const formValues = formValueSelector(QUALITY_ASSURANCE_ORDERS_FORM.name);
  const tasks = formValues(state, 'tasks');

  return {
    'order': ownProps.params.orderNumber,
    tasks,
    'orderStatus': state.form.qualityAssuranceOrders.values.status,
    'loading': state.form.qualityAssuranceOrders.loading,
    'savingItem': state.form.qualityAssuranceOrders.savingItem,
    'availableTasksList': state.tasksAssignmentInQualityAssuranceOrders.tasksList,
    'permissions': state.session.permissions,
    'push': ownProps.history.push,
    'goBack': ownProps.history.goBack,
  };
};

const {
  withRouter,
  fetchQualityAssuranceOrder,
  fetchTasksAvailableByOrder,
  fetchTasksForQualityAssuranceOrder,
  fetchTechnicians,
  manageTasksInQualityAssuranceOrder,
  addMessageBoxError,
  addOutsourcedInfo,
} = Actions;

export default withRouter(connect(mapStateToProps, {
  fetchQualityAssuranceOrder,
  fetchTasksAvailableByOrder,
  fetchTasksForQualityAssuranceOrder,
  fetchTechnicians,
  manageTasksInQualityAssuranceOrder,
  addMessageBoxError,
  addOutsourcedInfo,
})(form));
